import { render, staticRenderFns } from "./ProvidersTable.vue?vue&type=template&id=047d538b&"
import script from "./ProvidersTable.vue?vue&type=script&lang=js&"
export * from "./ProvidersTable.vue?vue&type=script&lang=js&"
import style0 from "./ProvidersTable.vue?vue&type=style&index=0&id=047d538b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports